import jssVariables from "../../jss_setup";

export const searchStripFlights = {
  searchStrip: {
    background: "#e8eff2",
    paddingBottom: 0,
    smallscreen: {
      background: "#b9ced8",
    },
  },
  text: {
    borderRadius: 0,
  },
  content: {
    borderRadius: 0,
  },
};

export const filtersBarFlights = {
  filtersBar: {
    background: "#e8eff2",
    smallscreen: {
      gridTemplateColumns: "1fr",
      justifyItems: "center",
      gridGap: 0,
      paddingTop: 0,
    },
  },
  btns: {
    smallscreen: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  btnStyles: {
    ButtonDefault: {
      background: jssVariables.colors.base_color,
      borderColor: jssVariables.colors.base_color,
      "&:hover": {
        color: jssVariables.colors.base_color,
        background: "white",
      },
    },
  },
};
